/** OHT has released the FOUP onto the stocker load port. */
export const STOCKER_DROP_LP_RELEASE_PROGRESS = 0.35;

/** OHT has taken the FOUP from the stocker load port. */
export const STOCKER_PICKUP_OHT_TAKE_PROGRESS = 0.75;

/** DROP: FOUP sits on load port before crane grabs it (OHT handoff). */
export const DROP_PORT_REST_END = 0.55;
/** DROP: OHT release complete / FOUP owned by stocker on the load-port tray. */
export const DROP_OHT_RELEASE = 0.35;
/** PICKUP: crane finished placing FOUP on port. */
export const PICKUP_PORT_READY = 0.45;
/** PICKUP: OHT takes FOUP. */
export const PICKUP_OHT_TAKE = 0.75;

/** Rack dot count while an OHT DROP is in progress. */
export function dropRackDisplayCount(
  progress: number,
  startCount: number,
  authoritativeCount: number,
  totalSlots: number
): number {
  if (progress + 1e-6 < STOCKER_DROP_LP_RELEASE_PROGRESS) {
    return Math.min(Math.max(0, startCount), totalSlots);
  }
  return Math.min(totalSlots, Math.max(startCount + 1, authoritativeCount));
}

/** Rack dot count while an OHT PICKUP is in progress. */
export function pickupRackDisplayCount(
  progress: number,
  startCount: number,
  authoritativeCount: number,
  totalSlots: number
): number {
  if (progress + 1e-6 < STOCKER_PICKUP_OHT_TAKE_PROGRESS) {
    return Math.min(Math.max(0, startCount), totalSlots);
  }
  return Math.min(totalSlots, Math.max(0, Math.min(startCount - 1, authoritativeCount)));
}

/**
 * Keep the destination slot and badge unchanged until the complete store
 * motion (including fork retraction) has finished.
 */
export function committedDropRackCount(
  progress: number,
  startCount: number,
  authoritativeCount: number,
  totalSlots: number
): number {
  if (progress < 1) return Math.min(Math.max(0, startCount), totalSlots);
  return Math.min(
    totalSlots,
    Math.max(authoritativeCount, Math.max(0, startCount) + 1)
  );
}
